export default __webpack_public_path__ + "e9602f18de7339b81637cc950cd02096.glb";